<template>
    <main class="min-h-96 flex-col justify-center">
        <div
            v-if="active === true"
            class="mx-auto grow pb-6"
        >
            <AlertBox
                v-if="active === true"
                :state="config.state.download ? 'success' : 'danger'"
                :icon="MdiInbox"
                :title="config.state.download ? t('notifyOk') : t('notifyError')"
            >
                <p
                    v-if="config.state.download === false"
                    class="py-1 text-sm"
                >
                    {{ t('previewFileNotCreated') }}
                    <br />{{ config.preset.fileName }}.{{ config.preset.extension }}
                </p>
                <p
                    v-if="config.state.download === true"
                    class="py-1 text-sm"
                >
                    {{ t('previewFileCreated') }}
                    <br />{{ config.preset.fileName }}.{{ config.preset.extension }}
                </p>
            </AlertBox>
        </div>
    </main>
</template>
<script setup>
    import AlertBox from '../ui/AlertBox.vue';
    import { MdiInbox } from 'materialdesignicons-vue3/icons/';

    defineExpose({
        name: 'PDFPreview',
    });

    const props = defineProps({
        config: {
            type: Object,
            required: true,
        },
        active: {
            type: Boolean,
            default: false,
        },
    });
    const config = props.config;
    const active = props.active;
</script>
